const ActiveMarkerColor = '#ad0006';
export default ActiveMarkerColor;
